
import { TPracticeTypes } from "../types/practiceTypes";
import { IUnitPin, TUnitMode } from "../types/unitTypes";
import { myAxios } from "../utils/common";

export interface ILiveLogUpdate {
  instructor_id: number;
  details?: IUnitPin;
  type?: TUnitMode;
}

export const updateUnitLiveLogFn = async (
  log_id: number,
  data: ILiveLogUpdate
): Promise<{ message: string }> =>
  myAxios.put(`/unit_cohort_log/${log_id}`, data).then((r) => r.data);

/*  */

export interface IOfflineLogUpdate {
  user_id: number;
  unit_id: number;
  details?: IUnitPin;
}

export const updateUnitOfflineLogFn = async (
  data: IOfflineLogUpdate
): Promise<{ message: string }> =>
  myAxios.post("/user_unit_location_log/", data).then((r) => r.data);

/*  */

export const getMccStudentsFn = async (data: {
  mcc_id: number;
}): Promise<{
  id: number;
  username: string;
  cohort_id: number;
}[]> =>
  myAxios.post("/module_cohort_content/getStudents", data).then((r) => r.data);


export interface IInitialScoreItem {
  practice_id: number;
  results: null | Record<string, string>;
  unit_ml_part_id: number;
  type: TPracticeTypes;
  description: unknown;
  order: null | number;
}

export const getMccInitialScoresFn = async (data: {
  mcc_id: number;
}): Promise<IInitialScoreItem[]> =>
  myAxios.post("/module_cohort_content/getInitialScores", data).then((r) => r.data);
